import { CRMProFlexLabels } from './crmThirdParty'

export enum DemoModalProFlexVariants {
  PRO_FLEX_GEOLOCATION = 'proFlexGeolocation'
}

export type DemoModalVariants = CRMProFlexLabels | DemoModalProFlexVariants
